/**
 * `openid` plus the `signup` scope, which makes Keycloak ask for and emit the
 * company claims. Every Keycloak request of the app asks for it: keycloak-js is
 * initialised with it (default of all login/registration URLs) and the signup
 * page passes it explicitly.
 */
export const SIGNUP_SCOPE = "openid signup";

/**
 * Plain `openid`, for entries that arrive through an invitation. It overrides
 * the `signup` default, so the registration page shows no company fields for
 * someone who is joining an existing account or collaboration.
 */
export const INVITATION_SCOPE = "openid";
